<template>
  <div id="database" @click="loginDataBase">
    <div class="leftlayout">
        <img class="rankpng" src="@/assets/images/data/sql.jpg" alt="">
        <span>数据库</span>
    </div>
    <div class="rightlayout">
        <img class="rankpng" src="@/assets/images/data/tahao.jpg" alt="">
        <span style="color:#6096E7">{{ vipContent }}</span>
        <span>，查看数据库</span>
    </div>
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import envnetBus from '@/utils/eBus'
export default {
  name: 'bannerItem',
  props: ['img_path', 'jump_id', 'title', 'type'],
  data() {
    return {
      isVip: '0',
      vipContent: 'VIP会员'
    }
  },
  mounted(){
    const vipType = JSON.parse(localStorage.getItem('user'))
    if (vipType) {
        if (vipType.is_vip == '0') {
          this.vipContent = '升级VIP'
        }
    } else {
      this.vipContent = '请登录后'
    }
  },
  methods: {
    loginDataBase() {
      // envnetBus.$emit('loginDataBase',false)
      const vipType = JSON.parse(localStorage.getItem('user'))
      if (vipType) {
        if (vipType.is_vip == '0') {
          Toast({
            message: '详细数据库只对VIP会员开放，请先成为VIP会员',
            position: 'middle',
            duration: 2000
          });
          this.$router.push({ path: '/open' })
        } else {
          Toast({
            message: 'VIP会员，正在进入数据库...',
            position: 'middle',
            duration: 2000
          });
          envnetBus.$emit('loginDataBase',false)
        }
      } else {
        Toast({
          message: '请先登录/注册',
          position: 'middle',
          duration: 2000
        });
        this.$router.push({ path: '/login' })
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
#database {
    width: 600px;
    margin: 60px auto;
    height:100px;
    background-color:#f2f2f2;
    border: solid 1px #d9d9d9;
    border-radius: 20px;
    padding:0 20px;
    .leftlayout{
        float: left;
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
        height:100px;
    }
    .leftlayout:after{
        content:'';
        width:1px;
        margin-left:20px;
        height:70%;
        background-color:#bfbfbf;
    }
    .rightlayout{
        display: flex;
        justify-content: center;
        align-items: center;
        height:100px;
    }
    .rankpng{
      width:50px;
      margin:20px;
    }
}
</style>
